import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export default function useAutoLogout(token, logout) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;

    try {
      const decoded = jwtDecode(token); // Decode JWT token to get user details
      const { exp } = decoded;
      const currentTime = Date.now() / 1000; // in seconds
      const expiry = exp * 1000; // convert to ms
      const timeout = expiry - Date.now();
      if (timeout > 0) {
        const timer = setTimeout(() => {
          logout();
          navigate("/login");
        }, timeout);

        return () => clearTimeout(timer);
      } else {
        logout();
        navigate("/login");
      }
    } catch (err) {
      logout();
      navigate("/login");
    }
  }, [token, logout, navigate]);
}
